<div class="login-bg bg-img" style="overflow-y: scroll;">
  <div class="container">
    <div class="row loginOuterWrap">
      <div class="col-md-6 col-md-offset-4 login-mid ui-sm-12">
        <div class="login-header ui-g-12">
          <div class="tiger-logo animated fadeIn">
          </div>
          <h1 class="animated fadeIn"><i class="fas fa-spinner-third fa-spin throbbing-icon"></i> Authenticating</h1>
        </div>
      </div>
      <div class="clearfix"> </div>
      <!-- <div class="col-md-12 col-lg-12 col-md-offset-4 login-links ui-sm-12">
        <a class="text-center" routerLink="/privacyPolicy">Privacy Policy | </a>
        <a class="text-center" routerLink="/privacyPolicy/cookie"> Cookies</a>
      </div> -->
    </div>

  </div>
</div>